
import React from 'react';
import styles from '../../styles/Login.module.css';
//import { useHistory } from 'react-router';
import { Link } from 'react-router-dom'
//import { logoutUser } from '../../firebaseConfig';
import { useHistory } from 'react-router';

const HeaderLogin = (props) => {

  const history = useHistory();
  const { isLogged } = props;
  console.log(isLogged)

  const clickHandler = () => {
    history.push('/');
  }
  return (
      <div className={styles.Header}>
        <div className={styles.LogoImage} onClick={clickHandler}>
          <img className={styles.Img} src={require('../../icons/logoheart.png')} alt="Logo" />
          <img className={styles.Img2} src={require('../../icons/zdravkoName.png')} alt="Logo" />
        </div>
        <nav className={styles.Nav}>
          <ul className={styles.Ul}>
            <li className={styles.Li}>
                <Link to="/" >Domov</Link>
            </li>
            <li className={styles.Li}>
                <Link to="/Koledar" >Koledar</Link>
            </li>
            {isLogged ? 
              <li className={styles.Li}>
                <Link to="/Application" >Namizje</Link>
              </li> : 
              <li className={styles.Li}>
                  <Link to="/Login" >Login</Link>
              </li>
            }
          </ul>
        </nav>
      </div>
  );
}

export default HeaderLogin;
